import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "clearfix" };
const _hoisted_3 = { class: "clearfix" };
const _hoisted_4 = { class: "d-flex flex-wrap gap-2" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("i", {
    class: "fa fa-check",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("i", {
    class: "fa fa-check",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("i", {
    class: "fa fa-exchange",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("label", { class: "ms-5 me-2 pt-2 mb-0" }, [
    /*#__PURE__*/ _createElementVNode("span", null, "Manufactured on")
], -1 /* HOISTED */);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" }, null, -1 /* HOISTED */);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("label", { class: "ms-2 me-2 pt-2 mb-0" }, [
    /*#__PURE__*/ _createElementVNode("span", null, "Replaced on")
], -1 /* HOISTED */);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" }, null, -1 /* HOISTED */);
const _hoisted_13 = {
    key: 2,
    class: "d-flex",
    style: { "width": "800px" }
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* HOISTED */);
const _hoisted_16 = [
    _hoisted_15
];
const _hoisted_17 = ["onClick"];
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* HOISTED */);
const _hoisted_19 = [
    _hoisted_18
];
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("i", {
    class: "fa fa-save",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("i", {
    class: "fa fa-times",
    "aria-hidden": "true"
}, null, -1 /* HOISTED */);
const _hoisted_22 = { class: "system-management-tree" };
const _hoisted_23 = { class: "component-tree component-tree-small" };
const _hoisted_24 = { class: "ms-2" };
const _hoisted_25 = { class: "fw-bold" };
const _hoisted_26 = {
    key: 0,
    class: "ms-1"
};
const _hoisted_27 = { key: 0 };
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("span", { class: "fst-italic" }, "Manufacturer:", -1 /* HOISTED */);
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("span", { class: "fst-italic" }, "   Model:", -1 /* HOISTED */);
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("span", { class: "fst-italic" }, "   Installed on:", -1 /* HOISTED */);
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("span", { class: "fst-italic" }, "   Next Replacement:", -1 /* HOISTED */);
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("span", { class: "fst-italic" }, "   Block Target Float Value:", -1 /* HOISTED */);
const _hoisted_33 = { key: 1 };
const _hoisted_34 = ["onClick"];
const _hoisted_35 = /*#__PURE__*/ _createElementVNode("span", { class: "fst-italic" }, "Manufacturer:", -1 /* HOISTED */);
const _hoisted_36 = /*#__PURE__*/ _createElementVNode("span", { class: "fst-italic" }, "   Model:", -1 /* HOISTED */);
const _hoisted_37 = /*#__PURE__*/ _createElementVNode("span", { class: "fst-italic" }, "   Installed on:", -1 /* HOISTED */);
const _hoisted_38 = /*#__PURE__*/ _createElementVNode("span", { class: "fst-italic" }, "   Next Replacement:", -1 /* HOISTED */);
const _hoisted_39 = /*#__PURE__*/ _createElementVNode("span", { class: "fst-italic" }, "   Block Target Float Value:", -1 /* HOISTED */);
const _hoisted_40 = {
    key: 1,
    class: "ms-1"
};
const _hoisted_41 = /*#__PURE__*/ _createElementVNode("span", { class: "fst-italic" }, "Manufactured on:", -1 /* HOISTED */);
const _hoisted_42 = /*#__PURE__*/ _createElementVNode("span", { class: "fst-italic" }, "   Replaced on:", -1 /* HOISTED */);
const _hoisted_43 = { class: "clearfix" };
const _hoisted_44 = { class: "col-sm-12 col-xs-12 col-md-12 bottom10" };
const _hoisted_45 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tManufacturer\r\n\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_46 = ["onClick"];
const _hoisted_47 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* HOISTED */);
const _hoisted_48 = [
    _hoisted_47
];
const _hoisted_49 = { class: "col-sm-12 col-xs-12 col-md-12 bottom10" };
const _hoisted_50 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tModel\r\n\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_51 = ["onClick"];
const _hoisted_52 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* HOISTED */);
const _hoisted_53 = [
    _hoisted_52
];
const _hoisted_54 = {
    key: 0,
    class: "col-sm-12 col-xs-12 col-md-12 bottom10"
};
const _hoisted_55 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tInstalled On\r\n\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_56 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" }, null, -1 /* HOISTED */);
const _hoisted_57 = {
    key: 1,
    class: "col-sm-12 col-xs-12 col-md-12 bottom10"
};
const _hoisted_58 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tWhen Next Replacement\r\n\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_59 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" }, null, -1 /* HOISTED */);
const _hoisted_60 = { class: "col-sm-12 col-xs-12 col-md-12 bottom10" };
const _hoisted_61 = /*#__PURE__*/ _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\tBlock Target Float Voltage (V)\r\n\t\t\t\t\t\t", -1 /* HOISTED */);
const _hoisted_62 = { class: "checkbox-wrapper" };
const _hoisted_63 = { class: "float-end float-start-sm" };
const _hoisted_64 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* HOISTED */);
const _hoisted_65 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_flat_pickr = _resolveComponent("flat-pickr");
    const _component_b_input_group_append = _resolveComponent("b-input-group-append");
    const _component_b_input_group = _resolveComponent("b-input-group");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_ComponentTreeVue = _resolveComponent("ComponentTreeVue");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_modal = _resolveComponent("b-modal");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    (!_ctx.isClient)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createVNode(_component_b_button, {
                                class: "mb-0",
                                "variant-": "secondary",
                                disabled: !_ctx.hasStringSelection() || _ctx.settingValues(),
                                onClick: _ctx.setManufactorerAndModel
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_6,
                                    _createTextVNode(" Set Manufacturer and Model\r\n\t\t\t\t\t\t")
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["disabled", "onClick"]),
                            _createTextVNode(),
                            _createVNode(_component_b_button, {
                                class: "mb-0",
                                "variant-": "secondary",
                                disabled: !_ctx.hasSelection() || _ctx.settingValues(),
                                onClick: _ctx.setManufactureDate
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_7,
                                    _createTextVNode(" Set Manufacture Date\r\n\t\t\t\t\t\t")
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["disabled", "onClick"]),
                            _createTextVNode(),
                            _createVNode(_component_b_button, {
                                class: "mb-0",
                                "variant-": "secondary",
                                disabled: !_ctx.hasSelection() || _ctx.settingValues(),
                                onClick: _ctx.setReplacmentDate
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_8,
                                    _createTextVNode(" Set Replacement Date\r\n\t\t\t\t\t\t")
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["disabled", "onClick"])
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createTextVNode(),
                    (_ctx.settingValues())
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (_ctx.settingManufacture)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _hoisted_9,
                                    _createTextVNode(),
                                    _createVNode(_component_b_input_group, {
                                        style: { "width": "160px" },
                                        class: "clearfix bottom0 me-2"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_flat_pickr, {
                                                modelValue: _ctx.manufactureDate,
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.manufactureDate) = $event)),
                                                class: "form-control",
                                                config: _ctx.datePickerConfig
                                            }, null, 8 /* PROPS */, ["modelValue", "config"]),
                                            _createTextVNode(),
                                            _createVNode(_component_b_input_group_append, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_button, {
                                                        type: "button",
                                                        variant: "outline-secondary",
                                                        "data-toggle": ""
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _hoisted_10
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    })
                                                ]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true),
                            _createTextVNode(),
                            (_ctx.settingReplacement)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _hoisted_11,
                                    _createTextVNode(),
                                    _createVNode(_component_b_input_group, {
                                        style: { "width": "160px" },
                                        class: "clearfix bottom0 me-2"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_flat_pickr, {
                                                modelValue: _ctx.replacementDate,
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.replacementDate) = $event)),
                                                class: "form-control",
                                                config: _ctx.datePickerConfig
                                            }, null, 8 /* PROPS */, ["modelValue", "config"]),
                                            _createTextVNode(),
                                            _createVNode(_component_b_input_group_append, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_button, {
                                                        type: "button",
                                                        variant: "outline-secondary",
                                                        "data-toggle": ""
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _hoisted_12
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    })
                                                ]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ], 64 /* STABLE_FRAGMENT */))
                                : _createCommentVNode("v-if", true),
                            _createTextVNode(),
                            (_ctx.settingManufacturerAndModel)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                    _createVNode(_component_multiselect, {
                                        name: "manufacturerId",
                                        modelValue: _ctx.manufacturer,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.manufacturer) = $event)),
                                        "track-by": "value",
                                        label: "text",
                                        placeholder: _ctx.selectPlaceholder,
                                        options: _ctx.batteryManufacturers,
                                        showLabels: false,
                                        allowEmpty: true,
                                        taggable: true,
                                        "tag-placeholder": "Press enter to add new manufacturer",
                                        onTag: _ctx.addStringManufacturer,
                                        disabled: !_ctx.isClientInstaller,
                                        "allow-empty": false
                                    }, {
                                        noResult: _withCtx(() => [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t")
                                        ]),
                                        option: _withCtx((props) => [
                                            _createElementVNode("div", null, [
                                                _createElementVNode("span", null, _toDisplayString(props.option.text), 1 /* TEXT */),
                                                _createTextVNode(),
                                                _createElementVNode("div", {
                                                    class: "float-end",
                                                    onClick: _withModifiers(($event) => (_ctx.deleteManufacturer(props.option)), ["stop", "prevent"])
                                                }, _hoisted_16, 8 /* PROPS */, _hoisted_14)
                                            ])
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue", "placeholder", "options", "onTag", "disabled"]),
                                    _createTextVNode(),
                                    _createVNode(_component_multiselect, {
                                        name: "modelId",
                                        modelValue: _ctx.model,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.model) = $event)),
                                        "track-by": "modelId",
                                        label: "modelName",
                                        class: "ms-2",
                                        placeholder: _ctx.selectPlaceholder,
                                        options: _ctx.stringModels,
                                        showLabels: false,
                                        allowEmpty: true,
                                        taggable: true,
                                        "tag-placeholder": "Press enter to add new model",
                                        onTag: _ctx.addStringModel,
                                        disabled: !_ctx.isClientInstaller,
                                        "allow-empty": false
                                    }, {
                                        noResult: _withCtx(() => [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t\t")
                                        ]),
                                        option: _withCtx((props) => [
                                            _createElementVNode("div", null, [
                                                _createElementVNode("span", null, _toDisplayString(props.option.modelName), 1 /* TEXT */),
                                                _createTextVNode(),
                                                _createElementVNode("div", {
                                                    class: "float-end",
                                                    onClick: _withModifiers(($event) => (_ctx.deleteControllerModel(props.option)), ["stop", "prevent"])
                                                }, _hoisted_19, 8 /* PROPS */, _hoisted_17)
                                            ])
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue", "placeholder", "options", "onTag", "disabled"])
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createTextVNode(),
                            _createElementVNode("div", null, [
                                _createVNode(_component_b_button, {
                                    class: "mb-0",
                                    "variant-": "primary",
                                    onClick: _ctx.update,
                                    disabled: (_ctx.settingManufacturerAndModel && (_ctx.manufacturer == null || _ctx.model == null)) || ((_ctx.settingManufacture || _ctx.settingReplacement) && _ctx.manufactureDate == null) || (_ctx.settingReplacement && _ctx.replacementDate == null)
                                }, {
                                    default: _withCtx(() => [
                                        _hoisted_20
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["onClick", "disabled"]),
                                _createTextVNode(),
                                _createVNode(_component_b_button, {
                                    class: "mb-0",
                                    "variant-": "seconday",
                                    onClick: _ctx.cancel
                                }, {
                                    default: _withCtx(() => [
                                        _hoisted_21
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["onClick"])
                            ])
                        ], 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("ul", _hoisted_23, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.componentTree.children, (child, index) => {
                            return (_openBlock(), _createBlock(_component_ComponentTreeVue, {
                                key: index,
                                item: child,
                                parentId: -1,
                                "selected-nodes": _ctx.selectedComponentTreeNodes,
                                "onUpdate:selectedNodes": _cache[4] || (_cache[4] = ($event) => ((_ctx.selectedComponentTreeNodes) = $event)),
                                selectable: !_ctx.isClient
                            }, {
                                content: _withCtx(({ displayName, whenManufactured, whenLastReplacement, manufacturerName, blockTargetFloatVoltage, modelName, whenInstalled, whenNextReplacement, componentTypeId, componentId }) => [
                                    _createElementVNode("div", _hoisted_24, [
                                        _createElementVNode("div", _hoisted_25, _toDisplayString(displayName), 1 /* TEXT */),
                                        _createTextVNode(),
                                        (_ctx.isString(componentTypeId))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                                (_ctx.isClient)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                                        _hoisted_28,
                                                        _createTextVNode("  " + _toDisplayString(manufacturerName !== null && manufacturerName !== void 0 ? manufacturerName : '-') + " |\r\n\t\t\t\t\t\t\t\t\t\t\t", 1 /* TEXT */),
                                                        _hoisted_29,
                                                        _createTextVNode("  " + _toDisplayString(modelName !== null && modelName !== void 0 ? modelName : '-') + " |\r\n\t\t\t\t\t\t\t\t\t\t\t", 1 /* TEXT */),
                                                        _hoisted_30,
                                                        _createTextVNode("  " + _toDisplayString(_ctx.getDateFormatted(whenInstalled)) + " |\r\n\t\t\t\t\t\t\t\t\t\t\t", 1 /* TEXT */),
                                                        whenNextReplacement
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                _hoisted_31,
                                                                _createTextVNode("  " + _toDisplayString(_ctx.getDateFormatted(whenNextReplacement)) + " |\r\n\t\t\t\t\t\t\t\t\t\t\t", 1 /* TEXT */)
                                                            ], 64 /* STABLE_FRAGMENT */))
                                                            : _createCommentVNode("v-if", true),
                                                        _createTextVNode(),
                                                        _hoisted_32,
                                                        _createTextVNode("  " + _toDisplayString(blockTargetFloatVoltage !== null && blockTargetFloatVoltage !== void 0 ? blockTargetFloatVoltage : '-') + " " + _toDisplayString(blockTargetFloatVoltage ? '(V)' : ''), 1 /* TEXT */)
                                                    ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                                        _createElementVNode("a", {
                                                            class: "blue",
                                                            onClick: _withModifiers(($event) => (_ctx.editString(componentId)), ["stop"])
                                                        }, [
                                                            _hoisted_35,
                                                            _createTextVNode("  " + _toDisplayString(manufacturerName !== null && manufacturerName !== void 0 ? manufacturerName : '-') + " |\r\n\t\t\t\t\t\t\t\t\t\t\t\t", 1 /* TEXT */),
                                                            _hoisted_36,
                                                            _createTextVNode("  " + _toDisplayString(modelName !== null && modelName !== void 0 ? modelName : '-') + " |\r\n\t\t\t\t\t\t\t\t\t\t\t\t", 1 /* TEXT */),
                                                            _hoisted_37,
                                                            _createTextVNode("  " + _toDisplayString(_ctx.getDateFormatted(whenInstalled)) + " |\r\n\t\t\t\t\t\t\t\t\t\t\t\t", 1 /* TEXT */),
                                                            whenNextReplacement
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                    _hoisted_38,
                                                                    _createTextVNode("  " + _toDisplayString(_ctx.getDateFormatted(whenNextReplacement)) + " |\r\n\t\t\t\t\t\t\t\t\t\t\t\t", 1 /* TEXT */)
                                                                ], 64 /* STABLE_FRAGMENT */))
                                                                : _createCommentVNode("v-if", true),
                                                            _createTextVNode(),
                                                            _hoisted_39,
                                                            _createTextVNode("  " + _toDisplayString(blockTargetFloatVoltage !== null && blockTargetFloatVoltage !== void 0 ? blockTargetFloatVoltage : '-') + " " + _toDisplayString(blockTargetFloatVoltage ? '(V)' : ''), 1 /* TEXT */)
                                                        ], 8 /* PROPS */, _hoisted_34)
                                                    ]))
                                            ]))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(),
                                        (_ctx.isBlock(componentTypeId))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                                _hoisted_41,
                                                _createTextVNode("  " + _toDisplayString(_ctx.getDateFormatted(whenManufactured)) + " ", 1 /* TEXT */),
                                                whenLastReplacement
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _hoisted_42,
                                                        _createTextVNode("  " + _toDisplayString(_ctx.getDateFormatted(whenLastReplacement)), 1 /* TEXT */)
                                                    ], 64 /* STABLE_FRAGMENT */))
                                                    : _createCommentVNode("v-if", true)
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ])
                                ]),
                                _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["item", "selected-nodes", "selectable"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ])
            ])
        ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.loaded]
        ]),
        _createTextVNode(),
        _createVNode(_component_b_modal, {
            id: "string_popup",
            modelValue: _ctx.editingString,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.editingString) = $event)),
            "header-bg-variant": "normal",
            size: "md"
        }, {
            title: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.selectedString.displayName), 1 /* TEXT */)
            ]),
            footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_63, [
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "primary",
                        onClick: _ctx.saveString,
                        disabled: !_ctx.isClientInstaller
                    }, {
                        default: _withCtx(() => [
                            _hoisted_64,
                            _createTextVNode(" Save\r\n\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick", "disabled"]),
                    _createTextVNode(),
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "secondary",
                        onClick: _ctx.closeString
                    }, {
                        default: _withCtx(() => [
                            _hoisted_65,
                            _createTextVNode(" Close\r\n\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ])
            ]),
            default: _withCtx(() => [
                _createTextVNode(),
                _createVNode(_component_b_container, { clearfix: "" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, [
                                _hoisted_45,
                                _createTextVNode(),
                                _createVNode(_component_multiselect, {
                                    name: "stringManufacturerId",
                                    modelValue: _ctx.stringManufacturer,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.stringManufacturer) = $event)),
                                    "track-by": "value",
                                    label: "text",
                                    placeholder: _ctx.selectPlaceholder,
                                    options: _ctx.batteryManufacturers,
                                    showLabels: false,
                                    allowEmpty: true,
                                    taggable: true,
                                    "tag-placeholder": "Press enter to add new manufacturer",
                                    onTag: _ctx.addStringManufacturer,
                                    disabled: !_ctx.isClientInstaller
                                }, {
                                    noResult: _withCtx(() => [
                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t")
                                    ]),
                                    option: _withCtx((props) => [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("span", null, _toDisplayString(props.option.text), 1 /* TEXT */),
                                            _createTextVNode(),
                                            _createElementVNode("div", {
                                                class: "float-end",
                                                onClick: _withModifiers(($event) => (_ctx.deleteManufacturer(props.option)), ["stop", "prevent"])
                                            }, _hoisted_48, 8 /* PROPS */, _hoisted_46)
                                        ])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue", "placeholder", "options", "onTag", "disabled"])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_49, [
                                _hoisted_50,
                                _createTextVNode(),
                                _createVNode(_component_multiselect, {
                                    name: "stringModelId",
                                    modelValue: _ctx.stringModel,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.stringModel) = $event)),
                                    "track-by": "modelId",
                                    label: "modelName",
                                    placeholder: _ctx.selectPlaceholder,
                                    options: _ctx.stringModels,
                                    showLabels: false,
                                    allowEmpty: true,
                                    taggable: true,
                                    "tag-placeholder": "Press enter to add new model",
                                    onTag: _ctx.addStringModel,
                                    disabled: !_ctx.isClientInstaller
                                }, {
                                    noResult: _withCtx(() => [
                                        _createTextVNode("\r\n\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t")
                                    ]),
                                    option: _withCtx((props) => [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("span", null, _toDisplayString(props.option.modelName), 1 /* TEXT */),
                                            _createTextVNode(),
                                            _createElementVNode("div", {
                                                class: "float-end",
                                                onClick: _withModifiers(($event) => (_ctx.deleteControllerModel(props.option)), ["stop", "prevent"])
                                            }, _hoisted_53, 8 /* PROPS */, _hoisted_51)
                                        ])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue", "placeholder", "options", "onTag", "disabled"])
                            ]),
                            _createTextVNode(),
                            (_ctx.selectedString.whenInstalled !== undefined)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                    _hoisted_55,
                                    _createTextVNode(),
                                    _createVNode(_component_b_input_group, { class: "clearfix bottom0" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_flat_pickr, {
                                                modelValue: _ctx.whenInstalled,
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.whenInstalled) = $event)),
                                                class: "form-control",
                                                config: _ctx.datePickerConfig,
                                                disabled: !_ctx.isClientInstaller
                                            }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                                            _createTextVNode(),
                                            _createVNode(_component_b_input_group_append, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_button, {
                                                        type: "button",
                                                        variant: "outline-secondary",
                                                        "data-toggle": ""
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _hoisted_56
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    })
                                                ]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createTextVNode(),
                            (_ctx.selectedString.whenNextReplacement !== undefined)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                    _hoisted_58,
                                    _createTextVNode(),
                                    _createVNode(_component_b_input_group, { class: "clearfix bottom0" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_flat_pickr, {
                                                modelValue: _ctx.whenNextReplacement,
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.whenNextReplacement) = $event)),
                                                class: "form-control",
                                                config: _ctx.datePickerConfig,
                                                disabled: !_ctx.isClientInstaller
                                            }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                                            _createTextVNode(),
                                            _createVNode(_component_b_input_group_append, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_button, {
                                                        type: "button",
                                                        variant: "outline-secondary",
                                                        "data-toggle": ""
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _hoisted_59
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    })
                                                ]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_60, [
                                _hoisted_61,
                                _createTextVNode(),
                                _createVNode(_component_b_form_input, {
                                    type: "number",
                                    modelValue: _ctx.selectedString.blockTargetFloatVoltage,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.selectedString.blockTargetFloatVoltage) = $event)),
                                    modelModifiers: { trim: true },
                                    min: "0",
                                    max: "1000",
                                    step: "0.1"
                                }, null, 8 /* PROPS */, ["modelValue"]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_62, [
                                    _createVNode(_component_b_form_checkbox, {
                                        modelValue: _ctx.replicateBlockTargetFloatVoltage,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.replicateBlockTargetFloatVoltage) = $event)),
                                        size: "lg"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\tReplicate this value for other Strings\r\n\t\t\t\t\t\t\t")
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["modelValue"])
                                ])
                            ])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }),
                _createTextVNode()
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"])
    ]));
}
